"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _DefaultScreen = _interopRequireDefault(require("../../02_molecules/DefaultScreen"));

var _EditPassengerForm = _interopRequireDefault(require("../../02_molecules/EditPassengerForm"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var MobileEditPassengerPopup = function MobileEditPassengerPopup(_ref) {
  var sdk = _ref.sdk,
      _ref$onEdit = _ref.onEdit,
      onEdit = _ref$onEdit === void 0 ? function () {} : _ref$onEdit,
      _ref$onBack = _ref.onBack,
      onBack = _ref$onBack === void 0 ? function () {} : _ref$onBack,
      _ref$onDelete = _ref.onDelete,
      onDelete = _ref$onDelete === void 0 ? function () {} : _ref$onDelete,
      _ref$passenger = _ref.passenger,
      passenger = _ref$passenger === void 0 ? {} : _ref$passenger,
      t = _ref.translator,
      translatorForNamespace = _ref.translatorForNamespace;
  return /*#__PURE__*/_react["default"].createElement(_DefaultScreen["default"], {
    title: t('Edit passenger'),
    onBack: onBack
  }, /*#__PURE__*/_react["default"].createElement(_EditPassengerForm["default"], {
    sdk: sdk,
    translatorForNamespace: translatorForNamespace,
    defaultValue: passenger,
    submitButtonLabel: t('Save'),
    onSubmit: onEdit,
    leftButtonLabel: t('Delete'),
    onLeftButtonClick: onDelete,
    leftButtonColor: 'google plus',
    config: {
      name: {
        title: t('Passenger name'),
        subtitle: t('Will display on your tickets'),
        show: true
      },
      phone: {
        title: t('Phone number'),
        subtitle: t('Used to send ticket information'),
        show: true
      },
      ssn: {
        title: t('Identification document'),
        subtitle: t('Necessary to onboard the bus'),
        show: true
      },
      email: {
        show: true
      },
      address: {
        show: true
      }
    }
  }));
};

var _default = MobileEditPassengerPopup;
exports["default"] = _default;